import { getLogger } from '@tbitop/logging';

export const log = getLogger('authentication');
